import { render, staticRenderFns } from "./NewApp.vue?vue&type=template&id=261054e1"
import script from "./NewApp.vue?vue&type=script&lang=js"
export * from "./NewApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports